import { message } from "antd";
import dayjs from "dayjs";
import { isEmpty } from "lodash";
import { GRAPHQL_URL } from "../config";

export const mediaDownloader = async imageSrc => {
  try {
    if (isEmpty(imageSrc) || !imageSrc) {
      message.error("This media file cannot downloaded, please contact support.");
    }
    const fileName = imageSrc.split("/").pop();
    // Extract the file extension from the file name
    const extension = fileName.includes(".") ? fileName.split(".").pop() : "jpg";
    const res = await fetch(
      `${GRAPHQL_URL.replace("graphql", "download-image")}?url=${encodeURIComponent(imageSrc)}`,
      { method: "GET" }
    );
    console.log("download-image res:::", res);
    const blobImage = await res.blob();
    const url = window.URL.createObjectURL(blobImage);
    const a = document.createElement("a");
    a.href = url;
    a.download = `smai-media-file-${dayjs()}.${extension}`;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 60000);
    a.remove();
  } catch (err) {
    message.error(`Something went wrong, Error: - ${err.message}`);
    console.error("Error in mediaDownloader", err);
  }
};
